import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { LinearProgress } from '@material-ui/core';

import Box from 'retired/Box';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectEpics } from 'utils/injectEpics';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';

import { selectLoading } from './selectors';
import epics from './epics';
import reducer from './reducer';
import { CampaignFormType, initAction } from './types';
import CampaignForm from './CampaignForm';

const key = 'campaignPage';

const CampaignPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const campaignType = queryParams.get('type') as CampaignFormType | undefined;
  const duplicate = queryParams.get('duplicate');
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);
  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics });
  useEffect(() => {
    dispatch(initAction(id || 'new', Boolean(duplicate), campaignType));
  }, [campaignType, dispatch, id, duplicate]);

  if (user && (!user.hasPrivilege(Privileges.CAMPAIGN_MANAGE) || !organization?.isCompany())) {
    history.replace('/');
  }

  return (
    <>
      {loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        <CampaignForm />
      )}
    </>
  );
};

export default CampaignPage;
